import { useState } from 'react';

const useHeader = () => {
  const [isMainMenuToggled, setIsMainMenuToggled] = useState(false);

  const onMobileMenuClose = () => {
    setIsMainMenuToggled(false);
  };

  return {
    onMobileMenuClose,
    isMainMenuToggled,
    setIsMainMenuToggled,
  };
};

export default useHeader;
